import { Controller } from "@hotwired/stimulus"

// Scales a fixed-size stage (a 960×540 deck board) to the width of its
// wrapper, so a preview fits the column it is in on every screen.
// The wrapper carries data-scale-width-value with the stage's own width.
export default class extends Controller {
  static values = { width: { type: Number, default: 960 } }

  connect() {
    this.observer = new ResizeObserver(() => this.fit())
    this.observer.observe(this.element)
    this.fit()
  }

  disconnect() {
    this.observer.disconnect()
  }

  fit() {
    const scale = this.element.clientWidth / this.widthValue
    this.element.style.setProperty("--scale", scale.toFixed(4))
  }
}
